import { useRef, useState } from "react";
import KendaraanServiceList from "./kendaraan-service-list";
import KendaraanServiceEdit from "./kendaraan-service-edit";

const KendaraanServiceMain = (props, { className }) => {
  const listRef = useRef(null);

  const [visibleEditorDialog, setVisibleEditorDialog] = useState(false);
  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  // handle ui event section

  const handleOnClickRowEdit = (row) => {
    setEditorData(row);
    setVisibleEditorDialog(true);
  };

  const handleOnClickAddNew = () => {
    setEditorData({});
    setVisibleEditorDialog(true);
  };

  const handleOnConfirmedEdit = (data) => {
    listRef.current.handleOnUpdateViewRow(data);
    setVisibleEditorDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <KendaraanServiceEdit
        visible={visibleEditorDialog}
        onHide={() => setVisibleEditorDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedEdit}
      />

      <KendaraanServiceList
        ref={listRef}
        onClickRowEdit={handleOnClickRowEdit}
        onClickAddNew={handleOnClickAddNew}
      />
    </div>
  );
};

export default KendaraanServiceMain;
